import { usePostEventClick } from '@repo/api/endpoints/event';
import { useDeviceInfo, useViewTimer } from '@repo/analytics';
import { useProviderStore } from '@repo/store/provider';
import { deriveFlowType } from '@repo/store/helpers';
import { providerType } from '@repo/shared/types';
var getActivityProvider = function (activity, currentProvider) {
    if ([
        'LIBERIS_CONSENTS',
        'LIBERIS_COMPANY_DETAILS',
        'LIBERIS_PERSONS_DETAILS',
        'LIBERIS_SUMMARY_ACCEPT',
        'LIBERIS_AGREEMENT_SIGN',
        'MORE_OFFERS',
    ].includes(activity)) {
        return [providerType.enum.liberis];
    }
    if (['PRAGMA_SUMMARY_ACCEPT', 'PRAGMA_AGREEMENT_SIGN'].includes(activity)) {
        return [providerType.enum.pragma];
    }
    if (currentProvider) {
        return [currentProvider];
    }
    return [];
};
export function useEventClick(merchantResponseData) {
    var postEventClick = usePostEventClick().mutate;
    var device = useDeviceInfo();
    var getSpentTime = useViewTimer();
    var currentProvider = useProviderStore().state.currentProvider;
    return function (payload, onSettled) {
        var _a, _b;
        if (!merchantResponseData)
            return;
        var activityProvider = getActivityProvider(payload.activity, currentProvider);
        postEventClick({
            requestId: merchantResponseData.requestId,
            activity: payload.activity,
            previousActivity: payload.previousActivity,
            nextActivity: payload.nextActivity,
            spentTime: getSpentTime(),
            providers: (_a = payload.providers) !== null && _a !== void 0 ? _a : {
                enabled: merchantResponseData.currentProvider,
                selected: activityProvider,
            },
            device: device,
            flowType: (_b = payload.flowType) !== null && _b !== void 0 ? _b : deriveFlowType(merchantResponseData),
        }, { onSettled: onSettled });
    };
}
